/* ***
 * TRANSLATIONS *
 *** */

export const LOADING = 'Loading...';
export const ERROR_MESSAGE_TITLE = 'Oops, something went wrong';
export const ERROR_MESSAGE_DETAILS =
  'We are not able to load some page elements. Please refresh the page or come back later.';

const bodyElement = document.getElementsByTagName('body')[0];
const translationFromBody = {
  loading: LOADING,
  errorMessageTitle: ERROR_MESSAGE_TITLE,
  errorMessageDetails: ERROR_MESSAGE_DETAILS,
};
const translation = bodyElement.getAttribute('data-language-settings') || '{}';
const { texts = translationFromBody } = JSON.parse(translation);
const { loading, errorMessageTitle, errorMessageDetails } = texts;
const result = {
  loading,
  errorMessageTitle,
  errorMessageDetails,
};

export default result;
